import React from 'react'

import { Box, Table, Text } from '@superlogica/design-system'
import { BoxTabTable, BoxTitleTable } from 'styles/global-style'

const View = ({ isLoading, isError, data = [], columns, refetch, setListaFaturaValue }) => {
  return data.length > 0 ? (
    <>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xs"
        radius="md"
        className="flex align-center"
      >
        <BoxTitleTable paddingSize="none">
          <Text className="mr-xxxs">Faturas</Text>
          <Text color="neutral400" size="body02">
            {`${data.length} itens`}
          </Text>
        </BoxTitleTable>
      </BoxTabTable>
      <Box border borderColor="neutral300" bgColor="neutral0" paddingSize="none" radius="xs">
        <Table
          data={data}
          columns={columns}
          tableName="faturas"
          retry={refetch}
          error={isError}
          loading={isLoading}
        />
      </Box>
    </>
  ) : (
    <Box
      border
      borderColor="neutral300"
      bgColor="neutral0"
      paddingType="squish"
      paddingSize="md"
      radius="xs"
    >
      <Text>{'Cliente não possui faturas'}</Text>
    </Box>
  )
}

export default View
